module.exports = __webpack_public_path__ + "img/Group 632.40832998.png";